import React, { useState } from "react";
import "./App.css";
import BotConfigForm from "./components/backtest/BotConfigForm";
import BacktestResults from "./components/backtest/BacktestResults";
import Sidebar from "./Sidebar";
import { useSidebar } from "./context/sidebarContext";
import styles from "./styles/Dashboard.module.css";
import { Link } from "react-router-dom";
import { NavigationBarTestingMode } from "./components/navbar/NavigationBarTestingMode";

function Backtest() {
  const { isOpen, toggleSidebar } = useSidebar();

  // State to control whether to show backtest results
  const [showResults, setShowResults] = useState(false);
  // State to store the bot configuration
  const [botConfig, setBotConfig] = useState({});
  // State to track if backtest is running
  const [isRunning, setIsRunning] = useState(false);
  // State to track backtest progress
  const [progress, setProgress] = useState(0);
  const [backtestData, setBacktestData] = useState({});

  // Handle run backtest button click
  const handleRunBacktest = (data, configData) => {
    setBacktestData(data);
    setBotConfig(configData);
    // setIsRunning(true);
    // Start fake progress
    setShowResults(true);

    // Simulate backtest progress
    // const interval = setInterval(() => {
    //   ((prev) => {
    //     if (prev >= 100) {
    //       clearInterval(interval);
    //       setIsRunning(false);
    //       setShowResults(true);
    //       return 100;
    //     }
    //     return prev + 10;
    //   });
    // }, 500); // Update every 500ms
  };

  // Handle stop backtest button click
  const handleStopBacktest = () => {
    setIsRunning(false);
    // If we were showing results, keep showing them
  };

  return (
    <div className={styles.dashboard}>
      <NavigationBarTestingMode />
      <Sidebar isOpen={isOpen} onClose={toggleSidebar} />
      <div
        className={
          styles.mainContent +
          " h-screen overflow-y-auto no-scrollbar flex flex-col items-start !gap-0 !pb-10 container mx-auto max-w-6xl lg:!pt-[11vh]"
        }
      >
        <p className="text-sm font-semibold mt-6">
          <Link to="/testing-mode" className="text-[#0E0F11]">
            Which Tes...
          </Link>
          &nbsp;/ <span className="text-[#0E0F11]/60">Backtest</span>
        </p>
        <h1 className="text-2xl md:text-3xl font-bold m-0 mt-6">
          Back Testing Bot
        </h1>

        <main className="w-full mt-6">
          <div className="w-full p-5 bg-white rounded-2xl">
            <BotConfigForm
              onRunBacktest={handleRunBacktest}
              isRunning={isRunning}
              setIsRunning={setIsRunning}
              setProgress={setProgress}
              progress={progress}
            />
          </div>

          {showResults && (
            <BacktestResults results={backtestData} botConfig={botConfig} />
          )}
        </main>
      </div>
    </div>
  );
}

export default Backtest;
